import React from 'react';
import ReactDOM from 'react-dom';
import Blog from './blog.js';

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('blog')) {
    ReactDOM.render(
      <Blog></Blog>,
      document.getElementById('blog')
    );
  }
})
